import React, {  lazy } from 'react';
import {
  Card,
} from 'antd';
import { Link } from 'react-router-dom';

import { PageHeader } from '../../../components/page-headers/page-headers';
import { Button } from '../../../components/buttons/buttons';
import { Main } from '../../styled';
const PacienteMainForm = lazy(() => import('./Form'));

const PacienteFormContainer = () => {
  
  return (
    <>
      <PageHeader
        buttons={[
          <Button className="btn-add_new" size="default" key="1" type="primary">
            <Link to="/admin/clinica/pacientes/listado">Ver todos</Link>
          </Button>,
        ]}
        ghost
        title="FICHA DEL PACIENTE"
      />
      <Main>      
          <PacienteMainForm />        
      </Main>
    </>
  );
};

export default PacienteFormContainer;
